<template>
  <v-container fluid class="pt-0">
    <v-row>
      <template>
        <Coverages :coverages="coverageObj" policy />
      </template>
      <template v-if="!coverageObj && !loading">
        Unable to get coverages. Please try again later.
      </template>
    </v-row>

    <v-dialog v-model="loading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Loading vehicle coverages...
          <v-progress-linear indeterminate color="white" class="mb-0" />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<style scoped>
</style>

<script>
import apiService from '@/services/shared/agentPortalApiService.js';
import coverageTranslator from '@/services/clientViewer/coverageTranslator.js';
import { mapState, mapActions } from 'vuex';

import Coverages from '@/components/Shared/Coverages.vue';

export default {
  name: 'VehicleCoverages',
  components: {
    Coverages
  },
  data: function () {
    return {
      loading: true,
      coverageObj: null
    };
  },
  computed: {
    ...mapState(['selectedLineOfBusinessCode']),
    clientId: function () {
      return this.$route.params.clientId;
    },
    policyOrderNumber: function () {
      return this.$route.params.policyOrderNumber;
    },
    lobCode: function () {
      return this.selectedLineOfBusinessCode;
    },
    vehicleId: function () {
      return this.$route.params.vehicleId;
    }
  },
  created: async function () {
    this.loading = true;

    var rs = await apiService.getVehicleCoverages(this.clientId, this.policyOrderNumber, this.lobCode, this.vehicleId);
    if (rs.code === 0 || rs.code === 2) {
      if ((rs.data || null) !== null) {
        this.coverageObj = { coverages: rs.data.map(x => coverageTranslator.translateCoverage(x)) };
      } else {
        this.coverageObj = { coverages: [] };
      }
    } else {
      this.setError(rs.message || 'An error occurred.');
    }

    this.loading = false;
  },
  methods: {
    ...mapActions(['setError'])
  }
};
</script>
